import { render, staticRenderFns } from "./SublessonDetail.vue?vue&type=template&id=0097535b&scoped=true&"
import script from "./SublessonDetail.vue?vue&type=script&lang=ts&"
export * from "./SublessonDetail.vue?vue&type=script&lang=ts&"
import style0 from "./SublessonDetail.vue?vue&type=style&index=0&id=0097535b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0097535b",
  null
  
)

export default component.exports